import React from 'react'
import '../styles/d3/checkbox.scss'

const Checkbox = props => {
  const {
    disabled,
    onClick,
    checked,
    label,
    toggle,
    stopPropagation,
    check = false,
    transition = false
  } = props
  const className = `${toggle ? 'toggle' : 'checkbox'} ${
    disabled ? 'disabled' : ''
  }`
  const _onClick = e => {
    if (stopPropagation) e.stopPropagation()
    onClick()
  }
  const disabledClass = disabled ? ' disabled' : ''
  return (
    <div onClick={disabled || !onClick ? null : _onClick} className={className}>
      <div className={`check${checked ? ' checked' : ''}${disabledClass}`}>
        {toggle && <span className='round-slider' />}
        {/* {checked && (
          <div className={`checkmark${check ? ' fas fa-check' : ''}`} />
        )} */}

        <div className={`checkmark${check ? ' fas fa-check' : ''}`} />

        {transition && <div className='check-transition' />}
      </div>
      <span className='label'>{label}</span>
    </div>
  )
}

export default Checkbox
